import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domClass from 'dojo/dom-class';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './LabourReviewHome.html?raw';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import FilterPanel from '../../../moreCore/UI/FilterPanel/FilterPanel';
import "./LabourReviewTable";

class LabourReviewHome extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    filterpanels: any = [];
    _isFilterResultLoaded = false;
    _currentFilterSettingsApplied: any = false;
    _currentFilterSettings: any = null;
    _timeout: any = null;

    _maxResultCount = 200;
    _currentStartIndex = 0;

    loadFilterOptions() {
        this.StandbyStart();
        var url = window.appRoot + "LabourReview/GetFilterOptions";


        this.RequestManager.post(
            url,
            {
                jsonData: null
            },
            lang.hitch(this, this._onLoadFilterOptionsResponse),
            lang.hitch(this, this._onLoadFilterOptionsError),
            false // sync
        );
    }

    _onLoadFilterOptionsResponse(response: any) {
        this.StandbyStop();

        console.log("_onLoadFilterOptionsResponse", response);

        var filteropt = response.filterPanelRoot;

        this.prepareFilteroptions(filteropt);

        domClass.remove(this.filterSection, "w3-hide");
    }

    _onLoadFilterOptionsError(error: any) {

        this.StandbyStop();

        this.showErrorDetailsDlg(error.Message, null, null, "ok", null);

        //alert("Filteroptionen können nicht geladen werden: " + error.Message);
    }

    /*
    prepareFilteroptions: function (data) {

        domConstruct.empty(this.filterPanelContainer);

        this.filterpanels = [];

        for (var i = 0; i < data.sections.length; i++) {

            var sectionData = data.sections[i];
            var fp = new FilterPanel();
            fp.outputFormat = data.format == "compact" ? "compact" : "default";
            this.filterpanels.push(fp);
            domConstruct.place(fp.domNode, this.filterPanelContainer)

            fp.name = sectionData.name;

            if (typeof (sectionData.sectionLabel) != "undefined") {
                fp.set("header", sectionData.sectionLabel);
            }

            if (typeof (sectionData.rules) != "undefined") {
                fp.set("rules", sectionData.rules);
            }

            if (typeof (sectionData.collapsible) != "undefined") {
                fp.set("collapsible", sectionData.collapsible, sectionData.isCollapsed === true);
            }

            for (var x = 0; x < sectionData.options.length; x++) {
                var optionData = sectionData.options[x];

                let opt = fp.addFilterOption(optionData);
            }

        }


        for (var i = 0; i < this.filterpanels.length; i++) {
            on(this.filterpanels[i], "serializedData", lang.hitch(this, this.checkDirtyState_delayed));

            // einmalig zu Beginn serialisieren
            this.filterpanels[i].serializeData();
        }
    },
    */

    prepareFilteroptions(data: any) {
        if (this.filterPanelContainer) {
            this.UiModder.domConstruct.empty(this.filterPanelContainer);
        }
        else {
            alert("this.filterPanelContainer not defined");
            return;
        }
        this.UiModder.domConstruct.empty(this.filterPanelContainer);
        var fp = new FilterPanel();
        this.filterpanel = fp;
        fp.placeAt(this.filterPanelContainer);
        // JS2TS: FilterPanelFormat is not imported/declared in this module (undefined identifier in the original) — preserving the bare-identifier read via window; do NOT "fix"
        fp.outputFormat = (window as any).FilterPanelFormat.compact; // das Format lassen wir jetzt mal fix. data.format == "compact" ? "compact" : "default";
        for (var i = 0; i < data.sections.length; i++) {
            var sectionData = data.sections[i];
            fp.addSection(sectionData);
        }
        on(this.filterpanel, "serializedData", lang.hitch(this, this.checkDirtyState_delayed));
        this.filterpanel.serializeData();
        // falls man noch was ergänzen möchte (readonly z.B.)
        //this.filterOptions_additionalConfig();
    }


    showErrorDetailsDlg(message: any, header: any, subtitle: any, buttons: any, callback: any) {
        let dlg = new GenericDialog();

        if (!header) {
            header = this.translations["LabourReview_Filter"];
        }

        dlg.show(message, header, subtitle, null, buttons, callback);
    }

    checkDirtyState_delayed(result: any) {

        // bestehendes Event unterbrechen
        if (this._timeout != null) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }

        this._timeout = setTimeout(lang.hitch(this, this.checkDirtyState, result), 100);
    }

    checkDirtyState(bForceFalse?: any) {
        if (bForceFalse === false) {
            this.isDirty = false;
            return;
        }
        var json = this.filterpanel.getData();//{ sections: this.filterpanel.getData() };
        var bValid = json !== null;
        this._currentFilterSettings = json;

        if (this._currentFilterSettingsApplied != JSON.stringify(this._currentFilterSettings) && bValid === true) {
            this.isDirty = true;
            this.setSubmitButtonStyle();
        } else {
            this.isDirty = false;
            this.setSubmitButtonStyle();
        }
    }

    /*
    checkDirtyState_delayed: function (result) {

        // bestehendes Event unterbrechen
        if (this._timeout != null) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }

        this._timeout = setTimeout(lang.hitch(this, this.checkDirtyState, result), 100);
    },

    checkDirtyState: function (bForceFalse) {
        //console.debug("checkDirtyState");

        if (bForceFalse === false) {
            this.set("dirty", false);
            return;
        }

        var json = { sections: [] };//, currentStartIndex: this._currentStartIndex, limit: this._maxResultCount };
        var bValid = true;
        var bAllCollapsed = true;

        for (var i = 0; i < this.filterpanels.length; i++) {
            var fp = this.filterpanels[i];

            json.sections.push(fp._jsonData);

            if (fp.valid != true) {
                bValid = false;
            }

            //if (fp._isCollapsed != true) {
            //    bAllCollapsed = false;
            //}
        }


        var jsonString = JSON.stringify(json)
        this._currentFilterSettings = jsonString;

        let bIsDirty = this._currentFilterSettingsApplied != this._currentFilterSettings && bValid === true;

        this.set("dirty", bIsDirty);

        //if (bAllCollapsed === true && bIsDirty != true) {
        //    domClass.add(this.sectionBtnSubmit, "w3-hide");
        //} else {
        //    domClass.remove(this.sectionBtnSubmit, "w3-hide");
        //}
    },
    */

    _setDirtyAttr(value: any) {


        this.isDirty = value === true;

        //console.debug("setDirty", this.isDirty);

        this.setSubmitButtonStyle();
    }

    setSubmitButtonStyle() {

        //console.debug("setSubmitButtonStyle", this.isDirty);

        domClass.remove(this.btnSubmit, "w3-disabled accentBG mds-hover-bright");

        var classesEnabled = "mds-hover-bright accentBG";
        var classesDisabled = "w3-disabled";
        if ((this.isDirty == true) && this._isRequestActive != true) {
            domClass.add(this.btnSubmit, classesEnabled);
            domClass.remove(this.btnSubmit, classesDisabled);
        } else {
            domClass.add(this.btnSubmit, classesDisabled);
            domClass.remove(this.btnSubmit, classesEnabled);
        }
    }

    _onClick_Submit(evt: any) {
        if (this._isRequestActive === true || (this.isDirty != true)) {
            return;
        }

        // irgendwie erzwingen, dass alle Steuerelemente ihren jetzt aktuellen Wert hergeben!
        for (let fp of this.filterpanels) {
            fp.serializeData();
        }

        domClass.add(this.filterSection, "w3-disabled");

        this._isFilterResultLoaded = false;

        this.getFilterData();
    }

    getFilterData() {
        //if (this.table) {
        //    this.StandbyStart(this.table);
        //}
        var url = window.appRoot + "LabourReview/GetLabourList";
        this._isRequestActive = true;
        this.setSubmitButtonStyle();
        let data = null;
        console.log("filter?", this._currentFilterSettings)

        data = this._currentFilterSettings;

        console.debug("getFilterData", data);


        data.limit = this._maxResultCount;
        data.currentStartIndex = this._currentStartIndex;

        var stringData = JSON.stringify(data);


        this.RequestManager.post(
            url,
            {
                jsonData: stringData
            },
            lang.hitch(this, this._onGetFilterDataResponse, this._currentFilterSettings),
            lang.hitch(this, this._onGetAxisDescriptorsError),
            false // sync
        );
    }

    _onGetFilterDataResponse(currentFiltersettings: any, response: any) {
        this.StandbyStop();
        domClass.remove(this.filterSection, "w3-disabled");
        this._isRequestActive = false;
        this._currentFilterSettingsApplied = currentFiltersettings;
        this.checkDirtyState();

        console.debug("_onGetFilterDataResponse", response);

        this.table.setData(response);

        domClass.remove(this.tableSection, "w3-hide");
    }

    _onGetFilterDataError(error: any) {
        this.showErrorDetailsDlg(error.Message, this.translations["LabourReview_Filter"], null, "ok", null);
        this.StandbyStop();
        domClass.remove(this.filterSection, "w3-disabled");
    }


    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse

    }
    postCreate() {
        super.postCreate.apply(this, arguments as any);
    }

    startup() {
        super.startup.apply(this, arguments as any);

        var title = this.translations["LabourReview__MainTitle"];
        if (title == "" || title == null || typeof (title) == "undefined") {
            title = "ekus Webtool";
        }
        document.title = title;

        this.loadFilterOptions();

    }
    destroy() {
        super.destroy.apply(this, arguments as any);
    }


}
LabourReviewHome.prototype.declaredClass = 'WidgetCollection.JDM.LabourReview.LabourReviewHome';

export default mdsWidget(LabourReviewHome);
